"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayAdapter = void 0;
var select_1 = require("./select");
var extend_1 = require("../utils/extend");
var ArrayAdapter = /** @class */ (function (_super) {
    __extends(ArrayAdapter, _super);
    function ArrayAdapter(element, options) {
        var _this = _super.call(this, element, options) || this;
        _this._dataToConvert = options.get('data') || [];
        return _this;
    }
    ArrayAdapter.prototype.binding = function (select, container) {
        _super.prototype.binding.call(this, select, container);
        this.addOptions(this.convertToOptions(this._dataToConvert));
    };
    ArrayAdapter.prototype.select = function (data) {
        var option = Array
            .from(this.core.element.querySelectorAll('option'))
            .find(function (elm) { return elm.value === data.id.toString(); });
        if (!option) {
            option = this.option(data);
            this.addOptions([option]);
        }
        _super.prototype.select.call(this, data);
    };
    ArrayAdapter.prototype.convertToOptions = function (data) {
        var _this = this;
        var existing = Array.from(this.core.element.querySelectorAll('option'));
        var existingIds = existing.map(function (option) { return _this.item(option).id; });
        var options = [];
        // Filter out all items except for the one passed in the argument
        var onlyItem = function (_item) { return function (_selfItem) { return _selfItem.value === _item.id; }; };
        for (var d = 0; d < data.length; d++) {
            var item = this.normalizeItem(data[d]);
            // Skip items which were pre-loaded, only merge the data
            if (existingIds.indexOf(item.id) >= 0) {
                var existingOption = existing.find(onlyItem(item));
                var existingData = this.item(existingOption);
                var newData = extend_1.extend({}, item, existingData);
                var $newOption = this.option(newData);
                existingOption.outerHTML = $newOption.outerHTML;
                continue;
            }
            var option = this.option(item);
            if (item.children) {
                var children = this.convertToOptions(item.children);
                option.append.apply(option, children);
            }
            options.push(option);
        }
        return options;
    };
    return ArrayAdapter;
}(select_1.SelectAdapter));
exports.ArrayAdapter = ArrayAdapter;
//# sourceMappingURL=array.js.map